// Shared Enter-to-search behavior for list search boxes.
// onSearch(value) runs the list's search; onReset(value), when given, runs instead for an empty term.
export const searchOrReset = (value, onSearch, onReset) => {
    if (onReset && !String(value == null ? '' : value).trim()) {
        onReset(value);
    } else {
        onSearch(value);
    }
};

export const searchOnEnter = (onSearch, onReset) => (e) => {
    if (e.key !== 'Enter' || (e.nativeEvent && e.nativeEvent.isComposing)) return;
    e.preventDefault();
    searchOrReset(e.currentTarget.value, onSearch, onReset);
};
